import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { topbarMenuConfig } from './topbar.config';
import { MenubarModule } from 'primeng/menubar';
import { EnvironmentService } from '@irian-ro/util-environment';
import { IpEnvironment } from '@ipensii/shared/domain-shared';

@Component({
  selector: 'ip-layout-topbar',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule, StyleClassModule, MenubarModule],
  templateUrl: 'topbar.component.html',
  styleUrls: ['topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent {
  @Input({ required: true }) colorizedMenu!: boolean;
  protected readonly topbarMenuConfig;

  constructor(env: EnvironmentService<IpEnvironment>) {
    const { presentationUrl, employerUrl } = env.getEnvironment();
    this.topbarMenuConfig = topbarMenuConfig(presentationUrl, employerUrl);
  }
}
